"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateInput = DateInput;

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function DateInput(props) {
  var className = props.className,
      errorMessage = props.errorMessage,
      fieldset = props.fieldset,
      formGroup = props.formGroup,
      hint = props.hint,
      id = props.id,
      items = props.items,
      namePrefix = props.namePrefix,
      onChange = props.onChange,
      attributes = _objectWithoutProperties(props, ["className", "errorMessage", "fieldset", "formGroup", "hint", "id", "items", "namePrefix", "onChange"]);

  var describedBy = (fieldset === null || fieldset === void 0 ? void 0 : fieldset['aria-describedby']) ? fieldset['aria-describedby'] : '';
  var hintComponent;
  var errorMessageComponent;
  var dateInputItems = [];

  if (hint) {
    var hintId = "".concat(id, "-hint");
    describedBy += " ".concat(hintId);
    hintComponent = /*#__PURE__*/_react["default"].createElement(_.Hint, _extends({}, hint, {
      id: hintId
    }));
  }

  if (errorMessage) {
    var errorId = id ? "".concat(id, "-error") : '';
    describedBy += " ".concat(errorId);
    errorMessageComponent = /*#__PURE__*/_react["default"].createElement(_.ErrorMessage, _extends({}, errorMessage, {
      id: errorId
    }));
  }

  if (items) {
    dateInputItems = items;
  } else {
    dateInputItems = [{
      name: 'day',
      className: 'govuk-input--width-2',
      type: 'text'
    }, {
      name: 'month',
      className: 'govuk-input--width-2',
      type: 'text'
    }, {
      name: 'year',
      className: 'govuk-input--width-4',
      type: 'text'
    }];
  }

  var itemComponents = dateInputItems.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: item.reactListKey || index,
      className: "govuk-date-input__item"
    }, /*#__PURE__*/_react["default"].createElement(_.Input, _extends({
      onChange: onChange
    }, item, {
      label: {
        children: item.label ? item.label : item.name.charAt(0).toUpperCase() + item.name.slice(1),
        className: 'govuk-date-input__label'
      },
      id: item.id ? item.id : "".concat(id, "-").concat(item.name),
      className: "govuk-date-input__input ".concat(item.className || ''),
      name: namePrefix ? "".concat(namePrefix, "-").concat(item.name) : item.name,
      type: "text",
      inputMode: "numeric",
      pattern: item.pattern ? item.pattern : '[0-9]*'
    })));
  });

  var innerHtml = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hintComponent, errorMessageComponent, /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "govuk-date-input ".concat(className || '')
  }, attributes, {
    id: id
  }), itemComponents));

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "govuk-form-group".concat(errorMessage ? ' govuk-form-group--error' : '', " ").concat((formGroup === null || formGroup === void 0 ? void 0 : formGroup.className) || '')
  }, fieldset ? /*#__PURE__*/_react["default"].createElement(_.Fieldset, _extends({}, fieldset, {
    "aria-describedby": describedBy,
    role: "group"
  }), innerHtml) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, innerHtml));
}